class FooterBlock extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.isConnected) {
      this.cacheElements();
    }
  
    if (this.isConnected && !this.initialized) {
      this.initialized = true;

      this.mql.addListener(this.update);
      this.waitForStylesheetAndLoad();
    }
  }
  
  cacheElements() {
    this.update = this.update.bind(this);

    this.triggers = this.querySelectorAll('.Footer__BlockHeading--trigger');
    this.panels = this.querySelectorAll('.Footer__List[data-category]');

    this.mql = window.matchMedia('(max-width: 768px)');
    this.isShowingMobileView = this.mql.matches;
  }

  waitForStylesheetAndLoad() {
    if (document.readyState == 'complete') {
      this.init();
    } else {
      window.addEventListener('load', () => {
        this.init();
      });
    }
  }

  init() {
    this.initDrawers();
    this.showViewBasedOnWidth();
  }

  /**
   * Drawers should be active on mobile only
   */
  update(e) {
    this.isShowingMobileView = e.matches;
    this.showViewBasedOnWidth();
  }
  
  showViewBasedOnWidth() {
    if (this.isShowingMobileView) {
      this.showMobileView();
    } else {
      this.showDesktopView();
    }
  }

  showMobileView() {
    this.triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
  }

  showDesktopView() {
    this.triggers.forEach(t => t.setAttribute('aria-expanded', 'true'));
    this.panels.forEach(p => p.style.removeProperty('height'));
  }

  /**
   * Mobile only drawers
   */
  initDrawers() {
    this.triggers.forEach(trigger => {
      // Start closed
      trigger.setAttribute('aria-expanded', 'false');

      trigger.addEventListener('click', (e) => {
        const category = trigger.dataset.category;
        const matchingPanel =
          Array.from(this.panels).find(p => p.dataset.category === category);

        NUtils.slideToggle(matchingPanel);

        NUtils.toggleBooleanAttribute(trigger, 'aria-expanded');
      });
    });
  }
}
customElements.define('footer-block', FooterBlock);